'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _require = require('../../constants/storageProfileVisibility'),
    PARTNER = _require.PARTNER,
    INTERNAL = _require.INTERNAL;

var _require2 = require('./endpointsMapper'),
    applyEndpointACL = _require2.applyEndpointACL;
/**
 * Determine whether a storageProfile belongs to a partner or not.
 *
 * @param accountId account to compare against
 * @param storageProfile
 * @returns {boolean} true if the storage profile belongs to a partner
 */


var isPartner = function isPartner(accountId, storageProfile) {
    return storageProfile && storageProfile.accountId !== accountId;
};

/**
 * Select only non-sensitive attributes from a partner storage profile.
 *
 * @param storageProfile
 * @returns {*} A redacted storage profile
 */
var mapPartnerStorageProfile = function mapPartnerStorageProfile(accountId, _ref) {
    var endpoint = _ref.endpoint,
        createdBy = _ref.createdBy,
        createdByAuthId = _ref.createdByAuthId,
        lastModifiedBy = _ref.lastModifiedBy,
        lastModifiedByAuthId = _ref.lastModifiedByAuthId,
        url = _ref.url,
        authentication = _ref.authentication,
        metadata = _ref.metadata,
        rest = _objectWithoutProperties(_ref, ['endpoint', 'createdBy', 'createdByAuthId', 'lastModifiedBy', 'lastModifiedByAuthId', 'url', 'authentication', 'metadata']);

    var filteredAttributes = _extends({}, rest, {
        type: PARTNER
    });
    //Sometimes we have only endpointId but other times we will have hydrated endpoint object in the storage profile object
    if (endpoint) {
        filteredAttributes.endpoint = applyEndpointACL(accountId)(endpoint);
    }
    return filteredAttributes;
};

/**
 * Create a sanitised list of storage profiles. Partner storage profiles have sensitive attributes removed.
 *
 * @param accountId
 * @param storageProfileList
 * @returns {*} List of redacted storage profiles
 */
var mapStorageProfiles = function mapStorageProfiles(accountId, storageProfileList) {
    return storageProfileList.map(mapStorageProfile(accountId));
};

var mapOwnStorageProfile = function mapOwnStorageProfile(_ref2, accountId) {
    var endpoint = _ref2.endpoint,
        rest = _objectWithoutProperties(_ref2, ['endpoint']);

    var returningProfile = _extends({}, rest, {
        type: INTERNAL
    });
    if (endpoint) {
        returningProfile.endpoint = applyEndpointACL(accountId)(endpoint);
    }
    return returningProfile;
};
/**
 * Create a sanitised storage profile. Partner storage profile have sensitive attributes removed.
 *
 * @param accountId
 * @param storageProfile
 * @returns {*} Redacted storage profile
 */
var mapStorageProfile = function mapStorageProfile(accountId) {
    return function (storageProfile) {
        if (isPartner(accountId, storageProfile)) {
            return mapPartnerStorageProfile(accountId, storageProfile);
        } else {
            return mapOwnStorageProfile(storageProfile, accountId);
        }
    };
};

module.exports = {
    mapStorageProfiles: mapStorageProfiles,
    mapStorageProfile: mapStorageProfile
};